import { ILangItem, ILangOptions, ILangParams, ILangPath } from "../langProvider.t";
import _ from "lodash";

function getLangPath(lang: ILangItem, path: ILangPath = '', params: ILangParams = {}, options: ILangOptions = {}) {
    const emptyDefault = !!options.emptyDefault;
    let langString = _.get(lang, path, emptyDefault ? '' : path.toString()) as string;
    const paramsKeys = Object.keys(params);
    paramsKeys.forEach(paramKey => {
        langString = langString.replaceAll(`{{${paramKey}}}`, params[paramKey]);
    });
    return langString;
}

export default getLangPath;
